import React from 'react';
import { RESPONSIVE_CLASSES } from '../../styles/emotion/mixins/responsive';
import AccordionV2 from '../AccordionV2';
import { LinkV2 } from '../LinkV2';
import {
  AccordionWrapper,
  ContentWrapper,
  FooterWrapper,
  LeftRailWrapper,
  LinksWrapper,
  StyledH5,
  StyledHr,
  StyledLi,
} from './PreauthFooterV3.styles';
import PreauthFooterV3Terms from './PreauthFooterV3Terms';
import PreAuthFooterV3ZolaInfo, { PreAuthFooterV3ZolaInfoProps } from './PreAuthFooterV3ZolaInfo';

const ABOUT: FooterSectionProps = {
  links: [
    { href: '/about/index', linkText: 'Our story' },
    { href: 'https://welcome.zola.com/for-vendors/', linkText: 'Become a Zola vendor' },
    { href: '/wedding-registry/invite', linkText: 'Refer a friend' },
    { href: '/wedding-registry/couple-reviews', linkText: 'Reviews' },
    { href: 'https://baby.zola.com', linkText: 'Zola Baby' },
    { href: '/about/team', linkText: 'Careers' },
    { href: '/about/press', linkText: 'Press' },
  ],
};

const ADVICE_AND_SUPPORT: FooterSectionProps = {
  links: [
    { href: '/expert-advice', linkText: 'Expert advice' },
    { href: '/faq', linkText: 'FAQs' },
    { href: '/order-status', linkText: 'Track order' },
    { href: '/order-status', linkText: 'Start a return' },
    { href: '/returns', linkText: 'Return policy' },
    { href: '/contact-us', linkText: 'Contact us' },
    { href: '/advisor', linkText: 'Team Z advisors' },
  ],
};

const PLAN_YOUR_WEDDING: FooterSectionProps = {
  links: [
    { href: '/wedding-vendors', linkText: 'Venues and vendors' },
    { href: '/wedding-planning/guests', linkText: 'Guest list' },
    { href: '/wedding-planning/website', linkText: 'Wedding websites' },
    { href: '/wedding-registry', linkText: 'Registry' },
    { href: '/wedding-planning/paper', linkText: 'Invites and paper' },
    { href: '/shop/category/wedding-shop', linkText: 'Boutique' },
    { href: '/wedding-albums/shop', linkText: 'Albums' },
  ],
};

type FooterSectionProps = {
  links: {
    href: string;
    linkText: string;
  }[];
};

const FooterSection = (props: FooterSectionProps) => {
  const { links } = props;
  return (
    <ul>
      {links.map((link) => {
        const { href, linkText } = link;
        return (
          <StyledLi key={`footer-link-${linkText}`}>
            <LinkV2 href={href} subtle noUnderline>
              {linkText}
            </LinkV2>
          </StyledLi>
        );
      })}
    </ul>
  );
};

const renderMobileFooterSection = () => {
  const items = [
    {
      hed: 'Plan your wedding',
      dek: <FooterSection {...PLAN_YOUR_WEDDING} />,
      id: 1,
    },
    {
      hed: 'About',
      dek: <FooterSection {...ABOUT} />,
      id: 2,
    },
    {
      hed: 'Advice and support',
      dek: <FooterSection {...ADVICE_AND_SUPPORT} />,
      id: 3,
    },
  ];
  return (
    <AccordionWrapper css={RESPONSIVE_CLASSES.excludeDesktop}>
      <AccordionV2 items={items} initialExpandedItems={1} arrowOnLeft={false} />
    </AccordionWrapper>
  );
};

type PreauthFooterV3Props = PreAuthFooterV3ZolaInfoProps;

const PreauthFooterV3 = ({ isGuest }: PreauthFooterV3Props): JSX.Element => {
  return (
    <FooterWrapper isGuest={isGuest}>
      <ContentWrapper>
        <LinksWrapper>
          {renderMobileFooterSection()}
          <LeftRailWrapper css={RESPONSIVE_CLASSES.desktopOnly}>
            <div>
              <StyledH5>Plan your wedding</StyledH5>
              <FooterSection {...PLAN_YOUR_WEDDING} />
            </div>
            <div>
              <StyledH5>About</StyledH5>
              <FooterSection {...ABOUT} />
            </div>
            <div>
              <StyledH5>Advice and support</StyledH5>
              <FooterSection {...ADVICE_AND_SUPPORT} />
            </div>
          </LeftRailWrapper>
          <StyledHr css={RESPONSIVE_CLASSES.desktopOnly} />
          <PreAuthFooterV3ZolaInfo isGuest={isGuest} />
        </LinksWrapper>
      </ContentWrapper>
      <PreauthFooterV3Terms />
    </FooterWrapper>
  );
};

export default PreauthFooterV3;
